// extracted by mini-css-extract-plugin
export default {"headerContainer":"CapsulesSettingsHeader_headerContainer__1MSMF","header":"CapsulesSettingsHeader_header__1sLCd","title":"CapsulesSettingsHeader_title__3Wr8u"};